module.exports = __webpack_public_path__ + "img/laptop-like.90180d58.svg";